// Resolve the same API base used by axios. Container builds use /api, while
// Roger's local dev:testing build points to the testing host explicitly.
// This identifies the API origin, not authenticated tenant/database isolation.
export function getEnvironmentKey(apiUrl, pageOrigin) {
  try {
    const host = new URL(apiUrl || '/api', pageOrigin).hostname.toLowerCase();
    if (host === 'voice-testing.qomplement.com') return 'testing';
    if (host === 'voice.qomplement.com') return 'production';
    if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') return 'local';
    return 'unknown';
  } catch {
    return 'unknown';
  }
}

export default getEnvironmentKey;
